// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../../../types';
import { SEMIBOLD, REGULAR } from '../../../../../../helpers/fontWeight';

export const PriceTitleWrapper = styled<any, Theme>('div')`
  display: flex;
  flex-direction: column;
  padding-top: .25rem;
`;

export const PriceTitle = styled<any, Theme>('span')`
  color: ${props => props.theme.cart.textColor};
  font-size: 1rem;
  font-weight: ${SEMIBOLD};
  line-height: 1.5;
`;

export const PriceSubTitle = styled<any, Theme>('span')`
  color: ${props => props.theme.cart.subTitle.color};
  font-size: .875rem;
  font-weight: ${REGULAR};
`;

export default null;
